
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yangiliklar/[name]",
      function () {
        return require("private-next-pages/yangiliklar/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yangiliklar/[name]"])
      });
    }
  